import { httpClient } from '@/services/http/httpClient'

type ResonseRiscTags = {
  id: string
  name: string
  color: string
  textColor: string
}

type GetRiscTagsParams = {
  portfolioId: string
  projectId: string
}

export const getRiscTags = async ({
  portfolioId,
  projectId,
}: GetRiscTagsParams) => {
  const { data } = await httpClient.get<ResonseRiscTags[]>(
    `/projects/risc-tags/${portfolioId}/${projectId}`,
  )

  return data
}
